/*
* @Author: withease-partner+cao@hashdash-group.com
 * @Description: the frame page of 「前面打勾选择框」
 * @modify Date:2021-2-17 16:43
 */

<template>
  <div class="cAgreeChoice-container">
    <li
      v-for="(item, index) in selectdata"
      :key="index"
      @click="handelSelect(item)"
      class="select-item"
      :class="{
        'select-active': item.isActive
      }"
    >
      <img
        :src="
          item.isActive
            ? require('@/assets/img/checkbox_check.png')
            : require('@/assets/img/checkbox.png')
        "
      />
      {{ item.value }}
    </li>
  </div>
</template>

<script>
export default {
  props: ['selectdata'],

  data() {
    return {};
  },

  methods: {
    handelSelect(item) {
      this.$emit('selectClick', item);
    }
  }
};
</script>

<style lang='less' scoped>
.cAgreeChoice-container {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .select-item {
    cursor: pointer;
    width: 100%;
    align-items: center;
    display: flex;
    font-size: 0.16rem;
    color: var(--text-blackcolor);
    margin-bottom: 0.36rem;
    font-weight: 500;
    img {
      width: 0.28rem;
      height: 0.28rem;
      margin-right: 0.13rem;
    }
  }
  .select-active {
    color: var(--maincolor);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Select/cArgeeChoice.vue